import { render, staticRenderFns } from "./CleaningStats.vue?vue&type=template&id=f82ed614&scoped=true"
import script from "./CleaningStats.vue?vue&type=script&lang=js"
export * from "./CleaningStats.vue?vue&type=script&lang=js"
import style0 from "./CleaningStats.vue?vue&type=style&index=0&id=f82ed614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82ed614",
  null
  
)

export default component.exports